import { render, staticRenderFns } from "./floatSaveBtn.vue?vue&type=template&id=c762fc1e&scoped=true&"
import script from "./floatSaveBtn.vue?vue&type=script&lang=js&"
export * from "./floatSaveBtn.vue?vue&type=script&lang=js&"
import style0 from "./floatSaveBtn.vue?vue&type=style&index=0&id=c762fc1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c762fc1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c762fc1e')) {
      api.createRecord('c762fc1e', component.options)
    } else {
      api.reload('c762fc1e', component.options)
    }
    module.hot.accept("./floatSaveBtn.vue?vue&type=template&id=c762fc1e&scoped=true&", function () {
      api.rerender('c762fc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/dialog/floatSaveBtn.vue"
export default component.exports